// DS8.2 (!) comes with consts:
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export const POPOVER_FOOTER_BUTTON_SIZE = 'medium';
import React from 'react';
import c from 'classnames';
import PopoverRootLayout from '../../layouts/PopoverRootLayout';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import PopoverHeader from '../../PopoverHeader';
import PopoverSimpleFooter from '../../PopoverSimpleFooter';
import SpreadLayout from '../../SpreadLayout';
import s from './Popover.scss';
/** Our standard popover.
 *
 * This component is not concerned with placement or show/hiding logic. That's the responsibility of the consumer.
 */ const Popover = (_param)=>{
    var { heading, subheading, headerIllustration, footerLeft, footerRight, footerMessage, footerButtonLabel, footerButtonBiData, footerButtonOnClick, footerButtonHref, className, onBackClick, onCloseClick } = _param, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "headerIllustration",
        "footerLeft",
        "footerRight",
        "footerMessage",
        "footerButtonLabel",
        "footerButtonBiData",
        "footerButtonOnClick",
        "footerButtonHref",
        "className",
        "onBackClick",
        "onCloseClick"
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY
    }, /*#__PURE__*/ React.createElement(PopoverRootLayout, _object_spread({
        className: c(s['root'], className),
        header: /*#__PURE__*/ React.createElement(PopoverHeader, {
            heading: heading,
            subheading: subheading,
            illustration: headerIllustration,
            onBackClick: onBackClick,
            onCloseClick: onCloseClick
        }),
        footer: footerLeft || footerRight ? /*#__PURE__*/ React.createElement(SpreadLayout, {
            left: footerLeft,
            right: footerRight
        }) : footerMessage || footerButtonLabel ? /*#__PURE__*/ React.createElement(PopoverSimpleFooter, {
            message: footerMessage,
            label: footerButtonLabel,
            biData: footerButtonBiData,
            href: footerButtonHref,
            onClick: footerButtonOnClick
        }) : undefined
    }, rest)));
};
Popover.displayName = 'Popover';
export default Popover;
